import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import theme from "Styles/theme.scss";
import React from "react";
import { IconProps } from "./types";

const CircleCrossmarkIcon = ({ colour, width }: IconProps) => {
  return (
    <FontAwesomeIcon
      icon={faCircleXmark}
      fontSize={width ?? "16px"}
      color={colour ?? theme.neutral7}
    />
  );
};

export default CircleCrossmarkIcon;
